//记得在 src\components\lang\zhLoad.js 里面添加对象
const landcertInfo = {
};
export default landcertInfo



// WEBPACK FOOTER //
// ./src/page/bd/run/landcertInfo/lang/landcertInfo.zh.js